const accordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09756 10.2439V16.3902H16.9024V10.2439H4.09756ZM3.84146 9.21951C3.41715 9.21951 3.07317 9.56349 3.07317 9.9878V16.6463C3.07317 17.0707 3.41715 17.4146 3.84146 17.4146H17.1585C17.5829 17.4146 17.9268 17.0707 17.9268 16.6463V9.9878C17.9268 9.56349 17.5829 9.21951 17.1585 9.21951H3.84146Z"
      fill="#6B00DF"
    />
    <path
      d="M3.07317 4.60976C3.07317 4.044 3.53181 3.58537 4.09756 3.58537H8.70732C9.27307 3.58537 9.73171 4.044 9.73171 4.60976C9.73171 5.17551 9.27307 5.63415 8.70732 5.63415H4.09756C3.53181 5.63415 3.07317 5.17551 3.07317 4.60976Z"
      fill="#6B00DF"
    />
    <path
      d="M3.07317 7.42683C3.07317 7.00251 3.41715 6.65854 3.84146 6.65854H17.1585C17.5829 6.65854 17.9268 7.00251 17.9268 7.42683C17.9268 7.85115 17.5829 8.19512 17.1585 8.19512H3.84146C3.41715 8.19512 3.07317 7.85115 3.07317 7.42683Z"
      fill="#6B00DF"
    />
  </svg>
);

export { accordionIcon };
